var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5",attrs:{"id":"map-test"}},[_c('mapbox',{attrs:{"access-token":"pk.eyJ1IjoiaG9ydGVuc2VncmVlbiIsImEiOiJja3N1Nm9iNGEwNjUyMm9xY2RlMDlwYWsxIn0.AMGi9L_80RYWk4sB5JYU5w","map-options":{
      style: 'mapbox://styles/mapbox/streets-v10',
      zoom: 5,
      center: [this.markers[0][0], this.markers[0][1]],
    }},on:{"map-init":_vm.displayMarkers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }